<ng-http-loader
    [backgroundColor]="'#111224'"
    [filteredHeaders]="['no-loader']">
</ng-http-loader>
<tour-step-template>
    <tour-step-template>
        <ng-template let-step="step" class="mt-2">
            <mat-card  (click)="$event.stopPropagation()">
                <mat-card-title>
                    <p class="text-title m-0">{{step?.title}}</p>
                </mat-card-title>
                <mat-card-content>
                    <p class="text-content m-0">{{step?.content}}</p>
                </mat-card-content>
                <mat-card-actions>
                    <button class="btn-next" *ngIf="tourService.hasNext(step)" [disabled]="!tourService.hasNext(step)"
                            (click)="tutorialNext(step)">
                        Continuar
                    </button>
                    <button [ngClass]="!tourService.hasNext(step)? 'btn-next' : 'btn-ignore'"
                            (click)="tutorialClosed()">
                        {{!tourService.hasNext(step)? 'Encerrar' : 'Ignorar'}}
                    </button>
                </mat-card-actions>
            </mat-card>
        </ng-template>
    </tour-step-template>
</tour-step-template>
<router-outlet [tourAnchor]="'0'"></router-outlet>